var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.75C11.3096 1.75 10.75 2.30964 10.75 3C10.75 3.69036 11.3096 4.25 12 4.25C12.6904 4.25 13.25 3.69036 13.25 3C13.25 2.30964 12.6904 1.75 12 1.75ZM9.25 3C9.25 1.48122 10.4812 0.25 12 0.25C13.5188 0.25 14.75 1.48122 14.75 3C14.75 4.51878 13.5188 5.75 12 5.75C11.0522 5.75 10.2164 5.27054 9.72195 4.54093L5.57394 7.02974C5.68774 7.33146 5.75 7.65846 5.75 8C5.75 8.18612 5.73151 8.36792 5.69627 8.54366L9.99197 11.1211C10.4938 10.585 11.2078 10.25 12 10.25C13.5188 10.25 14.75 11.4812 14.75 13C14.75 14.5188 13.5188 15.75 12 15.75C10.4812 15.75 9.25 14.5188 9.25 13C9.25 12.8142 9.26842 12.6328 9.30354 12.4573L5.00739 9.87962C4.50561 10.4153 3.79189 10.75 3 10.75C1.48122 10.75 0.25 9.51878 0.25 8C0.25 6.48122 1.48122 5.25 3 5.25C3.63069 5.25 4.2118 5.46232 4.67574 5.81937L9.25098 3.07423C9.25033 3.04956 9.25 3.02482 9.25 3ZM3 6.75C2.30964 6.75 1.75 7.30964 1.75 8C1.75 8.69036 2.30964 9.25 3 9.25C3.69036 9.25 4.25 8.69036 4.25 8C4.25 7.30964 3.69036 6.75 3 6.75ZM10.75 13C10.75 12.3096 11.3096 11.75 12 11.75C12.6904 11.75 13.25 12.3096 13.25 13C13.25 13.6904 12.6904 14.25 12 14.25C11.3096 14.25 10.75 13.6904 10.75 13Z",
    fill: "#747E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.52c898680e31c2da3fecf5d26257c789.svg";
export { ForwardRef as ReactComponent };